export function getAt(obj: unknown, path: string): unknown {
  if (!obj) return undefined
  return path
    .split('.')
    .reduce<unknown>(
      (cur, k) => (cur == null ? undefined : (cur as Record<string, unknown>)[k]),
      obj,
    )
}

export function setAt(obj: Record<string, unknown>, path: string, value: unknown): void {
  const parts = path.split('.')
  let cur: Record<string, unknown> = obj
  for (let i = 0; i < parts.length - 1; i++) {
    const k = parts[i]
    if (cur[k] == null || typeof cur[k] !== 'object') cur[k] = {}
    cur = cur[k] as Record<string, unknown>
  }
  cur[parts[parts.length - 1]] = value
}
